import useTitle from "../../hooks/useTitle"
import {   useParams } from "react-router-dom"

import { useState } from "react"
import LessonsList from "./LessonsList"
import {useMarkLessonsAsReportMutation} from "./lessonsApiSlice"
import GroupsCheckbox from "../../components/GroupsCheckbox"
//import { useGetGroupsQuery } from "../groups/groupsApiSlice"
function LessonsListFilter() {
    useTitle('geshtop-Exercise: Lessons List')
    const {groupId} = useParams()
  const[txt,setTxt] = useState('')
  const[all,setAll] = useState("")
  const [lessonsIds, setLessonIds] = useState([])
  const [groupsIds, setGroupsIds] = useState([])
  const [markLessonsAsReport, {data, error, isError}] = useMarkLessonsAsReportMutation()
  
      const changeId = (id) => {
          if (lessonsIds.includes(id)) {  
              setLessonIds(lessonsIds.filter(lessonId => lessonId !== id))
          } else {
              setLessonIds([...lessonsIds, id])
          }
      }
 
      const handleUpdateReport = async () => {
          if (lessonsIds.length === 0) {
              return
          }
          markLessonsAsReport({ ids: lessonsIds })
         
      }
    const content =(<>
      <div className="flex  gap-2 items-center">

     
            <input
                    className={`w-64 text-right text-base p-2 rounded-md`}
                    id="txt"
                    placeholder="הכנס שם שיעור"
                    name="txt"
                    type="text"
                    autoComplete="off"
                    value={txt}
                    onChange={e=>setTxt(e.target.value)}
                />
               
                <label htmlFor="all">הצג הכל</label>
                 <input 
                type="checkbox"
                className="form__checkbox"
                id="all"
                name="all"
                checked={all? true : false}
                onChange={e=>setAll(e.target.checked?"true":"")}
                />
                
                 <GroupsCheckbox groupsIds={groupsIds} setGroupsIds={setGroupsIds} /> 
                 <div>
<button
disabled={lessonsIds.length === 0}
onClick={handleUpdateReport}
 className="bg-gray-500 rounded p-2 text-white"> עדכן דווח</button>
 </div>
 </div>
             
        

  <LessonsList txt={txt} all={all} groupsIds={groupsIds} lessonsIds={lessonsIds} changeId={changeId} /> 

</> ) 
  return content;
}

export default LessonsListFilter